<template>
  <b-container
    fluid
    class="table-container py-3"
  >
    <b-table-simple
      striped
      class="table-fields w-100 mb-0"
    >
      <tbody>
        <tr v-for="item in items">
          <td>
            {{ item.originalName || item.name }}
          </td>
          <td style="text-align: right">
            <b-form-checkbox
              :id="`${$options.filters.displayName(item.name)}-checkbox`"
              :ref="`${item.name}-checkbox`"
              :checked="!!item.endpointId"
              :disabled="disable"
              @change="onChangeConfigStatus($event, item)"
            />
          </td>
        </tr>
      </tbody>
    </b-table-simple>
  </b-container>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';

const {mapState, mapActions} = createNamespacedHelpers('connectorScreen');

export default {
  name: 'ConnectorStaticPointsTable',
  props: {
    items: {
      type: [Object, Array],
      required: true,
    },
  },
  computed: {
    ...mapState({
      disable: state => state.disableDuringRequest,
    }),
  },
  methods: {
    onChangeConfigStatus(value, item) {
      this.$emit('on-change-config-status', value, item);
    },
  },
};
</script>

<style scoped>
.table-container {
  height: 250px;
}
</style>